
<row :class="{active: shouldHighlight}">
  <column class="row-title">
    <h4 @click="showBookmarkFolder">
      {{ folder.name }}
    </h4>
  </column>
  <suffix>
    <div class="dropdown">
      <button class="dropdown-toggle btn-icon clear-area controllers" :id="`folder_${folder.id}_actions`" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <icon class="kebab"></icon>
        <span class="sr-only">More Actions Dropdown</span>
      </button>
      <ul class="dropdown-menu dropdown-menu-right" :aria-labelledby="`folder_${folder.id}_actions`">
        <li v-if="folder.sort_order > 0">
          <button @click="changeSortOrderByOne(-1)" class="dropdown-item">Move Up</button>
        </li>
        <li v-if="folder.sort_order < bookmarkMenu.bookmark_folders.length">
          <button @click="changeSortOrderByOne(1)" class="dropdown-item">Move Down</button>
        </li>
        <li>
          <button @click="deleteFolder" class="dropdown-item">Delete</button>
        </li>
      </ul>
    </div>
  </suffix>
</row>
